var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidevector({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 583,
    height: 416,
    viewBox: "0 0 883 616",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M816.267 14.9811C900.568 -25.8836 974.887 30.8456 1001.51 64.3183L1006.64 919.974L6.7571 925.973C-12.5152 762.454 -1.47433 434.731 196.867 431.988C444.795 428.561 710.891 66.0619 816.267 14.9811Z",
    fill: "url(#paint0_linear_11914_2888)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11914_2888",
    x1: 909.822,
    y1: 93.7804,
    x2: 61.6942,
    y2: 682.845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#845BB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C5CAB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidevector);
export default __webpack_public_path__ + "static/media/sidevector.896e2942d4507b700cb45bddd3594d74.svg";
export { ForwardRef as ReactComponent };